namespace Solovis.Reports.Parameters {

    type PeriodType = "Months" | "Quarters";
    type ParameterValue = { number: number | null; select: PeriodType | null };

    export interface NumberPeriodsParameterControlOptions extends Solovis.UI.BaseControlOptions {
        initialValue: ParameterValue
    }

    export class NumberPeriodsParameterControl extends Solovis.UI.BaseControl {
        private static readonly DEFAULT_PARAMETER_VALUE: ParameterValue = { number: null, select: null };
        private static readonly MAX_MONTHS: number = 24;
        private static readonly MAX_QUARTERS: number = 8;

        private _initialParameterValue: ParameterValue;
        private _numberInput: JQuery;
        private _selectInput: JQuery;
        private _lastValidValue: string = '';

      constructor(options: NumberPeriodsParameterControlOptions, info) {
            super(options, info);

            this._initialParameterValue = options.initialValue ? 
                options.initialValue : NumberPeriodsParameterControl.DEFAULT_PARAMETER_VALUE;
        }

        public static getLabel(value): string | undefined {
            if (!value || value.number == null || !value.select) {
                return undefined;
            }
            return value.number + " " + value.select;
        }

        public doInit() {
        }

        public doRender() {
          var self = this;

          this.container.css({
            "padding": "0"
          });

          const containerDiv = $("<div>").css({
            "display": "flex",
            "align-items": "center",
            "width": "200px"
          }).appendTo(this.container);

          const numberSection = $("<div>")
            .css({
              "flex": "0 0 30%",
              "min-width": "0"
            })
            .appendTo(containerDiv);

          this._numberInput = $("<input>")
            .attr("type", "number")
            .attr("min", "1")
            .css({
              "width": "100%",
              "height": "28px",
              "margin": "0",
            })
            .appendTo(numberSection);

          if (this._initialParameterValue.number !== null && this._initialParameterValue.number !== undefined) {
            this._numberInput.val(this._initialParameterValue.number);
            this._lastValidValue = this._initialParameterValue.number.toString();
          }

          this._numberInput.on('keypress', function (e) {
            const char = String.fromCharCode(e.which);
            if (char === '.' || char === '-' || char === '+' || char === 'e' || char === 'E') {
              e.preventDefault();
            }
          });

          this._numberInput.on('input', function () {
            const currentValue = $(this).val()?.toString() || '';
            
            if (currentValue === '') {
              self._lastValidValue = '';
              return;
            }

            const numValue = parseFloat(currentValue);
            const maxAllowed = self._getMaxValueForPeriod();
            
            if (!isNaN(numValue) && numValue >= 1 && Number.isInteger(numValue) && numValue <= maxAllowed) {
              self._lastValidValue = numValue.toString();
              self.notifyParameterValueChanged();
            } else {
              $(this).val(self._lastValidValue);
            }
          });

          const selectSection = $("<div>")
            .css({
              "flex": "1 0",
              "min-width": "0"
            })
            .appendTo(containerDiv);

          this._selectInput = $("<select>")
            .css({
              "width": "100%",
              "height": "28px",
              "margin": "0",
              "border-color": "#ddd",
            })
            .appendTo(selectSection);

          $("<option>").val("").text("Select...").appendTo(this._selectInput);

          const selectOptions: { label: string; value: PeriodType }[] = [
            { "label": "Months", "value": "Months" },
            { "label": "Quarters", "value": "Quarters" }
          ]

          selectOptions.forEach(option => {
            $("<option>")
              .val(option.value)
              .text(option.label)
              .appendTo(this._selectInput);
          });

          if (this._initialParameterValue.select !== null && this._initialParameterValue.select !== undefined) {
            this._selectInput.val(this._initialParameterValue.select);
            this._updateMaxAttribute();
          }

          this._numberInput.change(function () {
            self.notifyParameterValueChanged();
          });

          this._selectInput.change(function () {
            self._updateMaxAttribute();
            self._validateCurrentValueAgainstNewMax();
            self.notifyParameterValueChanged();
          });
        }

        private _updateMaxAttribute(): void {
            const selectedValue = this._selectInput.val() as PeriodType;
            let maxValue: number;
            
            if (selectedValue === 'Months') {
                maxValue = NumberPeriodsParameterControl.MAX_MONTHS;
            } else if (selectedValue === 'Quarters') {
                maxValue = NumberPeriodsParameterControl.MAX_QUARTERS;
            } else {
                this._numberInput.removeAttr('max');
                return;
            }
            
            this._numberInput.attr('max', maxValue.toString());
        }

        private _validateCurrentValueAgainstNewMax(selectedPeriod?: PeriodType): void {
            const currentValue = this._numberInput.val();
            if (currentValue) {
                const maxAllowed = this._getMaxValueForPeriod(selectedPeriod);
                
                if (!isNaN(currentValue) && currentValue > maxAllowed) {
                    this._numberInput.val(maxAllowed);
                    this._lastValidValue = maxAllowed.toString();
                }
            }
        }

        private _getMaxValueForPeriod(periodType?: PeriodType): number {
            const selectedValue = periodType || (this._selectInput?.val() as PeriodType);
            
            if (selectedValue === 'Months') {
                return NumberPeriodsParameterControl.MAX_MONTHS;
            } else if (selectedValue === 'Quarters') {
                return NumberPeriodsParameterControl.MAX_QUARTERS;
            } else {
                return Number.MAX_SAFE_INTEGER;
            }
        }

        public setParameterValue(newValue: ParameterValue) {
            if (this._numberInput && this._selectInput) {
                const numberValue = newValue.number ?? '';
                this._numberInput.val(numberValue);
                this._lastValidValue = numberValue.toString();
                this._selectInput.val(newValue.select ?? '');
                this._updateMaxAttribute();
            } else {
                this._initialParameterValue = newValue ?? NumberPeriodsParameterControl.DEFAULT_PARAMETER_VALUE;
            }
        }

        public getParameterValue() {
            if (this._numberInput && this._selectInput) {
                const numberValue = this._numberInput.val();
                const selectValue = this._selectInput.val();

                return {
                    number: isNaN(numberValue) ? null : numberValue,
                    select: selectValue ?? null
                };
            } else {
                return this._initialParameterValue;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }
}